const sizeMap = {
  xl: 'px-4 py-2 text-[0.8125rem] leading-[1.25rem]', // weird variant used on the billing pages
  large: 'px-3 py-1 text-base',
  normal: 'px-2.5 py-1 text-sm',
  small: 'px-2 py-1 text-xs',
};

export const Pill = ({
  size = 'normal',
  text,
  colour,
  outline,
  backgroundColour
}: {
  size: keyof typeof sizeMap;
  text: string;
  colour: string;
  backgroundColour?: string; 
  outline?: boolean;
}) => (
  <div
    style={
      outline
        ? { borderColor: colour, backgroundColor: backgroundColour ?? `${colour}1A`, color: colour }
        : { borderColor: colour, backgroundColor: backgroundColour ?? colour, color: 'black' }
    }
    className={`border size-fit font-medium py-1 px-2 rounded-full whitespace-nowrap ${sizeMap[size]}`}
  >
    <span>{text}</span>
  </div>
);
